import { lightText, status } from 'src/colors';
import { BookingState } from '../../types/booking-state';

export const bookingStateColors: Record<BookingState, string> = {
  BOOKED: status.pending,
  STARTED: status.success,
  FINISHED: lightText.secondary,
  CANCELED: status.error,
};
